import { Box, Colors, Text, IcChevronRight } from 'basic-ui-lib';
import styled from 'styled-components';

interface MenuItemProps {
  icon?: React.ReactNode;
  label?: string;
  onClick?: () => void;
}
const MenuItem = ({ icon, label, onClick }: MenuItemProps) => {
  return (
    <Container onClick={onClick}>
      <Box display='flex' alignItems='center' gap={12}>
        {icon}
        <Text body_1 regular>
          {label}
        </Text>
      </Box>
      <IcChevronRight width={16} height={16} fill={Colors.neutral.bg[7]} />
    </Container>
  );
};

export default MenuItem;

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 8px;
  border-bottom: 1px solid ${Colors.neutral.bg[5]};
  justify-content: space-between;
  gap: 12px;

  &:hover {
    background-color: #f5f5f5;
  }
`;
